module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/admin-edit/admin-edit.component.css
// module id = ./src/app/components/admin/admin-edit/admin-edit.component.css
// module chunks = main